var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductGalleryImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1094 -2046)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    transform: "translate(1094 2046)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1117 2127)",
    fill: "#a8a8a8",
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.011em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Different Angles")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1128 2118)",
    fill: "#5e5873",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.011em",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "200*200")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGalleryImagePlaceholder);
export default __webpack_public_path__ + "static/media/ProductGalleryImagePlaceholder.fc2c7e0a4cc2cd61bc2ffa82f29b10ea.svg";
export { ForwardRef as ReactComponent };